import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuthContext } from '@/modules/auth/ui/AuthProvider';
import { useAdminApp } from '@/modules/admin/context/AdminAppContext';
import AdminAppDetailsSection from '@/modules/admin/components/AdminAppDetailsSection';
import AdminPricingSection from '@/modules/admin/components/AdminPricingSection';
import AdminAppHeader from '@/modules/admin/components/AdminAppHeader';

export default function AdminAppOverviewPage() {
  const { appId } = useParams();
  const { authFetch } = useAuthContext();
  const {
    app,
    hasQuote,
    loadApp,
    handleStatusChangeClick,
    showToast,
    setShowTransferModal,
    handleSendQuote,
  } = useAdminApp();

  return (
    <div className="mt-6">
      {/* App Header - Name, Status, URLs, Workflow */}
      <AdminAppHeader
        app={app}
        appId={appId}
        onStatusChange={handleStatusChangeClick}
        showToast={showToast}
        onTransferClick={() => setShowTransferModal(true)}
        authFetch={authFetch}
        onUpdate={() => loadApp(appId)}
      />

      {/* App Details Section - Description & Details */}
      <AdminAppDetailsSection
        app={app}
        appId={appId}
        authFetch={authFetch}
        showToast={showToast}
        onUpdate={() => loadApp(appId)}
      />

      {/* Pricing Section - At the bottom */}
      <AdminPricingSection
        app={app}
        appId={appId}
        hasQuote={hasQuote}
        authFetch={authFetch}
        showToast={showToast}
        onUpdate={() => loadApp(appId)}
        onSendQuote={handleSendQuote}
      />
    </div>
  );
}
